"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBBannerNotification;
var _react = _interopRequireDefault(require("react"));
var _exclamationCircle = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/exclamation-circle.svg"));
var _Error = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Error.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVBBannerNotification
 * @param type: define color
 * @param icon: custom icon
 * @param rightContent: right content
 * @param children: the node passed inside the Component
 * @returns alert with content
 */
function SVBBannerNotification(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bannerNotifications"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bannerNotifications__container ".concat(props.type ? props.type : 'info')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bannerNotifications__info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bannerNotifications__iconContainer"
  }, props.icon ? props.icon : props.type === 'error' ? /*#__PURE__*/_react.default.createElement("img", {
    alt: "error",
    className: "bannerNotifications__icon",
    src: _Error.default
  }) : /*#__PURE__*/_react.default.createElement("img", {
    alt: "exclamation",
    className: "bannerNotifications__icon",
    src: _exclamationCircle.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "bannerNotifications__text"
  }, props !== null && props !== void 0 && props.children ? props === null || props === void 0 ? void 0 : props.children : '')), (props === null || props === void 0 ? void 0 : props.rightContent) && /*#__PURE__*/_react.default.createElement("div", {
    className: "bannerNotifications__buttons"
  }, props.rightContent)));
}